export const LOCATION_GROUP_ADDRESS_REQUIRED_MESSAGE = 'An active warehouse requires an address.';
//# sourceMappingURL=location-group-address-required-message.js.map